import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebase";
import Login from "./components/Login";
import Home from "./components/Home";
import BackendTest from "./components/BackendTest";
import JoinGame from "./components/JoinGame";
import GamePage from "./components/GamePage";

// Protected route component
const ProtectedRoute = ({ children }) => {
  return auth.currentUser ? children : <Navigate to="/" />;
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(() => {
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return <div>Loading application...</div>;
  }

  return (
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route path="/join" element={<JoinGame />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pages/:pagePath"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route path="/game/:gameId" element={<GamePage />} />
      <Route
        path="/test-backend"
        element={
          <ProtectedRoute>
            <BackendTest />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
